import AxiosHttp from "../AxiosHttp";

export default class SistemaService extends AxiosHttp {
    async version() {
        const res = await this.http.get("/system/version");
        return this.handleRespose(res);
    }

    async getGoogleClientId(): Promise<string> {
        const res = await this.http.get("/system/conf/google/clientId");
        return this.handleRespose(res);
    }
}
